export class FilterationCriteria {
  nodeId: number;
}
